import Panel from './Panel';

export { Panel };
